import { Popover } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Item from "./components/Item";
import { getNavItems } from "./helper";
import styles from "./styles.module.css";

const NavBar = () => {
  const [items, setItems] = useState([]);
  const { t, i18n } = useTranslation();

  const goToLink = (item) => {
    // window.open(`${item[`link_${i18n.language}`]}`);
    window.location.href = `${item[`link_${i18n.language}`]}`;
  };

  useEffect(() => {
    setItems([...getNavItems(t)]);
  }, [i18n.language]);

  const renderItem = (item) => {
    if (item?.children?.length > 0) {
      const content = (
        <div className={styles.contentWrapper}>
          {item.children.map((i) => {
            return (
              <Item
                key={i.title}
                data={i}
                onClick={() => goToLink(i)}
                className={styles.subItem}
                textClassName={styles.popoverText}
              />
            );
          })}
        </div>
      );
      return (
        <Popover
          key={item.title}
          placement="bottom"
          trigger={"hover"}
          content={content}
          arrow={false}
          rootClassName="navbar-popover"
        >
          <div>
            <Item data={item} className={styles.item} />
          </div>
        </Popover>
      );
    } else {
      return (
        <Item
          key={item.title}
          data={item}
          onClick={() => goToLink(item)}
          className={styles.item}
        />
      );
    }
  };

  return <div className={styles.root}>{items.map(renderItem)}</div>;
};

export default NavBar;
